// types
import { PaletteThemeProps } from 'types/theme';
import { PalettesProps } from '@ant-design/colors';
import { PaletteColorOptions } from '@mui/material/styles';
import { ThemeMode } from 'types/config';
import { ramps } from '../colors';

// ==============================|| PRESET THEME - DEFAULT (V10 SIGNAL YELLOW) ||============================== //

/**
 * NuWay V10 palette (docs/design-system/COLORS.md). Primary is Signal Yellow
 * with BLACK contrast text — white on #F5C400 is 1.64:1. No blue, no violet:
 * `info` is a neutral ink.
 */
const Default = (colors: PalettesProps, mode: ThemeMode = ThemeMode.LIGHT): PaletteThemeProps => {
  const { grey } = colors;
  const { yellow, neutral, green, red, orange } = ramps;
  const dark = mode === ThemeMode.DARK;

  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };

  return {
    primary: {
      lighter: dark ? 'rgba(245,196,0,.14)' : yellow[100],
      100: yellow[100],
      200: yellow[200],
      light: dark ? yellow[400] : yellow[100],
      400: yellow[400],
      main: yellow[500],
      dark: dark ? yellow[600] : yellow[600],
      700: yellow[700],
      darker: yellow[800],
      900: yellow[900],
      contrastText: '#000000'
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500]!,
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: dark ? red[900] : red[100],
      light: red[300],
      main: dark ? red[500] : red[600],
      dark: red[700],
      darker: red[800],
      contrastText: '#FFFFFF'
    },
    warning: {
      lighter: dark ? orange[900] : orange[100],
      light: orange[300],
      main: dark ? orange[400] : orange[600],
      dark: orange[700],
      darker: orange[800],
      contrastText: dark ? '#000000' : '#FFFFFF'
    },
    info: {
      lighter: dark ? neutral[750] : neutral[100],
      light: neutral[300],
      main: dark ? neutral[300] : '#313130',
      dark: dark ? neutral[200] : '#000000',
      darker: '#000000',
      contrastText: dark ? '#000000' : '#FFFFFF'
    },
    success: {
      lighter: dark ? green[900] : green[100],
      light: green[300],
      main: dark ? green[300] : green[600],
      dark: green[700],
      darker: green[800],
      contrastText: dark ? '#000000' : '#FFFFFF'
    },
    grey: greyColors
  };
};

export default Default;
